import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ChakraProvider, withDefaultColorScheme } from '@chakra-ui/react'
import { extendTheme } from '@chakra-ui/react'
import customTheme from 'utils/customTheme'
import './assets/styles/global.scss'

const queryClient = new QueryClient()

if (process.env.REACT_APP_MODE === 'mock') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser')
  worker.start({
    onUnhandledRequest: 'bypass',
  })
}

// `extendTheme` pass your custom values
const theme = extendTheme(
  customTheme,
  withDefaultColorScheme({
    colorScheme: 'primary',
  }),
)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ChakraProvider>
  </React.StrictMode>,
)
